import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'ai-tool', {
    createHabit: 'Create habit',
    createHabitReasoning: 'Creating habit',
    createHabitOutput: 'Created habit',
    createHabitError: 'Error creating habit',
    updateHabit: 'Update habit',
    updateHabitReasoning: 'Updating habit',
    updateHabitOutput: 'Updated habit',
    updateHabitError: 'Error updating habit',
    createTask: 'Edit task',
    createTaskReasoning: 'Editing task',
    createTaskOutput: 'Edited task',
    createTaskError: 'Error editing task',
    updateTask: 'Update task',
    updateTaskReasoning: 'Updating task',
    updateTaskOutput: 'Updated task',
    updateTaskError: 'Error updating task',
    readHabit: 'Read habit',
    readHabitReasoning: 'Reading habit',
    readHabitOutput: 'Read habit',
    readHabitError: 'Error reading habit',
    readTask: 'Read task',
    readTaskReasoning: 'Reading task',
    readTaskOutput: 'Read task',
    readTaskError: 'Error reading task',
    createSampleHabits: 'Create sample habits',
    createSampleHabitsReasoning: 'Creating sample habits',
    createSampleHabitsOutput: 'Created sample habits',
    createSampleHabitsError: 'Error creating sample habits',
    deleteSampleHabits: 'Delete sample habits',
    deleteSampleHabitsReasoning: 'Deleting sample habits',
    deleteSampleHabitsOutput: 'Deleted sample habits',
    deleteSampleHabitsError: 'Error deleting sample habits',
    trashHabit: 'Send habit to trash',
    trashHabitReasoning: 'Sending habit to trash',
    trashHabitOutput: 'Sent habit to trash',
    trashHabitError: 'Error sending habit to trash',
    trashTask: 'Send task to trash',
    trashTaskReasoning: 'Sending task to trash',
    trashTaskOutput: 'Sent task to trash',
    trashTaskError: 'Error sending task to trash',
    selectInHabitCalendar: 'Select in habit calendar',
    selectInHabitCalendarReasoning: 'Selecting in habit calendar',
    selectInHabitCalendarOutput: 'Selected in habit calendar',
    selectInHabitCalendarError: 'Error selecting in habit calendar',
  });
}
